<template>
  <div class="dealings-check-accounts-view2-multi-currency">
    <div class="section operations" style="margin-bottom:2px;">
      <el-form inline style="margin-bottom:-8px;">
        <!--会计期间-->
        <el-form-item :label="$t('CargoMsg.Cargo_FiscalPeriod')">
          <el-select ref="fromFPRef" v-model="form.fromFP" style="width: 120px;" no="1">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_To')">
          <el-select v-model="form.toFP" style="width: 120px;" no="2">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <!--业务日期-->
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessDate')">
          <el-date-picker v-model="form.businessDateStart" format="yyyy-MM-dd" style="width: 120px;" no="3" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_To')">
          <el-date-picker v-model="form.businessDateEnd" format="yyyy-MM-dd" style="width: 120px;" no="4" />
        </el-form-item>
        <!--业务单号-->
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessDocNo')">
          <el-input v-model="form.projectNumber" style="width: 140px;" no="5" />
        </el-form-item>
        <!--摘要-->
        <el-form-item :label="$t('CargoMsg.Cargo_Abstract')">
          <el-input v-model="form.summaryText" style="width: 300px;" no="6" />
        </el-form-item>
        <br>
        <!--客户-->
        <el-form-item :label="$t('CargoMsg.Cargo_Customer')">
          <cargo-advance-select
            :callback-params="{key:'customer'}"
            :default-value="form.customer"
            :select-type="selectTypeNames.basic_data_Company"
            callback-method-type="value"
            filterable
            style="width: 298px;"
            no="7"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <!--科目-->
        <el-form-item :label="$t('CargoMsg.Cargo_AccountTitle')">
          <el-select ref="accountTitleRef" v-model="form.accountTitle" style="width: 298px;" :filterable="true" :clearable="true" no="8">
            <el-option
              v-for="(item,index) in currentAccountTitleCollection"
              :key="index"
              :label="accountTitleLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <!--币种-->
        <el-form-item :label="$t('CargoMsg.Cargo_Currency')">
          <el-select v-model="form.currency" style="width: 100px;" no="9">
            <el-option
              v-for="item in usedCurrencyCollection"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <!--销账-->
        <el-form-item :label="$t('CargoMsg.Cargo_WriteOff')" class="el-form-item-search">
          <el-radio-group v-model="form.clear" no="10">
            <el-radio :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
            <el-radio :label="1">{{ $t('CargoMsg.Cargo_WrittenOff') }}</el-radio>
            <el-radio :label="0">{{ $t('CargoMsg.Cargo_NotWrittenOff') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <br>
        <!--销售-->
        <el-form-item :label="$t('CargoMsg.Cargo_Sales')">
          <cargo-advance-select
            :callback-params="{key:'sales'}"
            :default-value="form.sales"
            :select-type="selectTypeNames.basic_data_User"
            callback-method-type="value"
            filterable
            style="width: 140px;"
            no="11"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <!--收支-->
        <el-form-item :label="$t('CargoMsg.Cargo_RevenueOrExpenditure')" class="el-form-item-search">
          <el-radio-group v-model="form.debitCrebit" no="12">
            <el-radio :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
            <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
            <el-radio :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <!--含期末调汇分录-->
          <el-checkbox v-model="form.showAdjustRateEntry" :label="$t('CargoMsg.Cargo_ShowAdjustRateEntry')" no="13" />
          <!--查询-->
          <el-button class="el-margin" type="primary" style="margin-left: 20px;" no="14" @click="doSearch">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <!--核销/反核销-->
          <el-button type="primary" no="15" @click="writeoffHandler">{{ $t('CargoMsg.Cargo_WriteOffReverseWriteOff') }}</el-button>
          <!--刷新是否已核销-->
          <el-button v-if="updateAccountingEntryPaidOffFlag && isPlatformService" type="primary" no="16" @click="updatePaidOffFlag">{{ $t('CargoMsg.Cargo_UpdatePaidOffFlag') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1;padding: 0px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :grid-params.sync="girdParams"
        :row-data="rowData"
        :auto-fit-content="false"
        style="height: 800px;"
        no="16"
      />
    </div>
    <div class="pagination-wrapper">
      <debit-credit-total-group :row-data="rowData" :visible="totalGroupVisible" style="float: right;margin-right: 10px" no="17" @clickCallBack="totalGroupVisible=!totalGroupVisible" />
    </div>
    <input-auxiliary-number-dialog
      :entry-list="inputAuxiliaryNumberDialog.entryList"
      :visible.sync="inputAuxiliaryNumberDialog.visible"
      no="18"
      @close="()=>inputAuxiliaryNumberDialog.visible=false"
      @refresh="doSearch"
    />
    <accounting-entry-window
      v-if="accountingEntryWindow.visible"
      :account-set="accountSet"
      :account-title-data-provider="accountingEntryWindow.accountTitleDataProvider"
      :index="accountingEntryWindow.index"
      :is-ext="isExt"
      :mapping-departments="mappingDepartments"
      :mapping-staffs="mappingStaffs"
      :prefix-data-provider="prefixDataProvider"
      :visible="accountingEntryWindow.visible"
      :voucher="accountingEntryWindow.voucher"
      no="19"
      @close="() => accountingEntryWindow.visible=false"
      @updateTargetDocumentNo="updateTargetDocumentNo"
    />
  </div>
</template>

<script>
import * as NumberUtils from '@/utils/NumberUtils'
import { cache } from '@/utils/cacheManager'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as accountingEntryApi from '@/api/financeManage/accountingEntry'
import { getLoading } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import DebitCreditTotalGroup from '@/views/cargo/v0/FinanceManage/AccountBook/components/DebitCreditTotalGroup'
import InputAuxiliaryNumberDialog from '@/views/cargo/v0/FinanceManage/AccountBook/components/InputAuxiliaryNumberDialog'
import * as accountingDocumentApi from '@/api/financeManage/accountingDocument'
import AccountingEntryWindow from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/AccountingEntryWindow'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'DealingsCheckAccountsView2MultiCurrency',
  components: { cargoAdvanceSelect, DebitCreditTotalGroup, InputAuxiliaryNumberDialog, AccountingEntryWindow },
  props: {
    accountSet: { type: Object, default: null },
    usedCurrencyCollection: { type: Array, default: null }
  },
  data() {
    return {
      totalGroupVisible: false,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          minWidth: 80,
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        },
        onCellDoubleClicked: event => {
          this.doubleClickHandler(event.data)
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 180,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_CustomerName'),
              field: 'ACCOUNT_NAME',
              width: 180, checkboxSelection: true,
              sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
              headerCheckboxSelection: true
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
              field: 'ACCOUNT_TITLE',
              width: 80
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Sales'),
              field: 'SALES_NAME',
              width: 80
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 110,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_BusinessDocNo'),
              field: 'PROJECT_NUMBER',
              width: 110
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 90,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_VoucherMonth'),
              field: 'MONTH',
              width: 90,
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 100,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_ProofDate'),
              field: 'DOCUMENT_DATE',
              width: 100
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 90,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_VoucherNo'),
              field: 'DOCUMENT_NO',
              width: 90,
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 200,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Abstract'),
              field: 'SUMMARY',
              width: 200,
              cellRenderer: params => {
                const value = params.value
                if (value === this.$t('CargoMsg.Cargo_SubTotal') || value === this.$t('CargoMsg.Cargo_OpeningBalance') || value === this.$t('CargoMsg.Cargo_TotalAmountOfCurrentPeriod') || value === this.$t('CargoMsg.Cargo_CurrentYearTotal')) {
                  return `<span style="font-weight: bold;font-family: 宋体,serif;font-style: italic;font-size: 14px">${value}</span>`
                } else {
                  return `<span style="font-weight: normal;font-style: normal;font-size: 12px">${value}</span>`
                }
              }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Currency'),
              field: 'SOURCE_CURRENCY',
              width: 80,
              cellStyle: { textAlign: 'center' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_DebitAmountOccurred'),
          field: '',
          width: 200,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'DEBIT_USD',
              width: 100,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'DEBIT_RMB',
              width: 100,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_CreditAmountOccurred'),
          field: '',
          width: 200,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'CREDIT_USD',
              width: 100,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'CREDIT_RMB',
              width: 100,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Loan'),
              field: 'DEBIT_CREBIT',
              width: 80,
              cellStyle: { textAlign: 'center' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_Balance'),
          field: '',
          width: 200,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'BALANCE_USD_SUM',
              width: 100,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'BALANCE_RMB_SUM',
              width: 100,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 120,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_BusinessHappenDate'),
              field: 'BUSINESS_DATE',
              width: 120
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_ExchangeRate'),
              field: 'EXCHANGE_RATE',
              width: 80,
              valueFormatter: params => {
                return ColumnUtils.formatNumber(params.value, 8)
              }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 100,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Department'),
              field: 'DEPARTMENT_NAME',
              width: 100
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 120,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_BusinessDocNo2'),
              field: 'PROJECT_NUMBER2',
              width: 120
            }
          ]
        }
      ],
      columnDefsRMB: [
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerName'),
          field: 'ACCOUNT_NAME',
          width: 180, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'ACCOUNT_TITLE',
          width: 80
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Sales'),
          field: 'SALES_NAME',
          width: 80
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessDocNo'),
          field: 'PROJECT_NUMBER',
          width: 110
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherMonth'),
          field: 'MONTH',
          width: 90,
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProofDate'),
          field: 'DOCUMENT_DATE',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherNo'),
          field: 'DOCUMENT_NO',
          width: 90,
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abstract'),
          field: 'SUMMARY',
          width: 200,
          cellRenderer: params => {
            const value = params.value
            if (value === this.$t('CargoMsg.Cargo_SubTotal') || value === this.$t('CargoMsg.Cargo_OpeningBalance') || value === this.$t('CargoMsg.Cargo_TotalAmountOfCurrentPeriod') || value === this.$t('CargoMsg.Cargo_CurrentYearTotal')) {
              return `<span style="font-weight: bold;font-family: 宋体,serif;font-style: italic;font-size: 14px">${value}</span>`
            } else {
              return `<span style="font-weight: normal;font-style: normal;font-size: 12px">${value}</span>`
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'SOURCE_CURRENCY',
          width: 80,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountOccurred'),
          field: 'DEBIT_RMB',
          width: 100,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountOccurred'),
          field: 'CREDIT_RMB',
          width: 100,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Loan'),
          field: 'DEBIT_CREBIT',
          width: 80,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Balance'),
          field: 'BALANCE_RMB_SUM',
          width: 100,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessHappenDate'),
          field: 'BUSINESS_DATE',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExchangeRate'),
          field: 'EXCHANGE_RATE',
          width: 80,
          valueFormatter: params => {
            return ColumnUtils.formatNumber(params.value, 8)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Department'),
          field: 'DEPARTMENT_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessDocNo2'),
          field: 'PROJECT_NUMBER2',
          width: 120
        }
      ],
      excelColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerName'),
          field: 'ACCOUNT_NAME',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'ACCOUNT_TITLE',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Sales'),
          field: 'SALES_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessDocNo'),
          field: 'PROJECT_NUMBER',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherMonth'),
          field: 'MONTH',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProofDate'),
          field: 'DOCUMENT_DATE',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherNo'),
          field: 'DOCUMENT_NO',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abstract'),
          field: 'SUMMARY',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'SOURCE_CURRENCY',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountOccurredSource'),
          field: 'DEBIT_USD',
          width: 100,
          valueFormatter: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountOccurredLocal'),
          field: 'DEBIT_RMB',
          width: 100,
          valueFormatter: params => {
            return this.numberFormat(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountOccurredSource'),
          field: 'CREDIT_USD',
          width: 100,
          valueFormatter: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountOccurredLocal'),
          field: 'CREDIT_RMB',
          width: 100,
          valueFormatter: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Loan'),
          field: 'DEBIT_CREBIT',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BalanceSource'),
          field: 'BALANCE_USD_SUM',
          width: 100,
          valueFormatter: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BalanceLocal'),
          field: 'BALANCE_RMB_SUM',
          width: 100,
          valueFormatter: params => {
            return this.numberFormat(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessHappenDate'),
          field: 'BUSINESS_DATE',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExchangeRate'),
          field: 'EXCHANGE_RATE',
          width: 100,
          valueFormatter: params => {
            return ColumnUtils.formatNumber(params.value, 8)
          }
        }
      ],
      rowData: [],
      selectTypeNames: TYPE_NAMES,
      operatorArr: [
        { name: ' ', value: -1 },
        { name: this.$t('CargoMsg.Cargo_GreaterThan'), value: 0 },
        { name: this.$t('CargoMsg.Cargo_EqualTo'), value: 1 },
        { name: this.$t('CargoMsg.Cargo_LessThan'), value: 2 }
      ],
      form: {
        fromFP: '',
        toFP: '',
        businessDateStart: '',
        businessDateEnd: '',
        projectNumber: '',
        summaryText: '',
        customer: 0,
        accountTitle: null,
        currency: '',
        clear: -1,
        sales: 0,
        debitCrebit: -1,
        showAdjustRateEntry: false
      },
      lbDbAmount: '',
      lbCreAmount: '',
      inputAuxiliaryNumberDialog: {
        entryList: [],
        visible: false
      },
      isExt: false,
      accountingEntryWindow: {
        visible: false,
        index: -1,
        voucher: null,
        accountTitleDataProvider: []
      },
      updateAccountingEntryPaidOffFlag: false
    }
  },
  computed: {
    // 当前会计期间
    currentFiscalPeriod() {
      return this.accountSet ? this.accountSet.currentFiscalPeriod : null
    },
    // 科目
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    // 会计期间
    fiscalPeriods() {
      return this.accountSet ? this.accountSet.fiscalPeriod : []
    },
    currentAccountTitleCollection() {
      return this.accountTitleCollection.filter(title => title.currentAccount)
    },
    // 部门
    mappingDepartments() {
      return this.accountSet ? this.accountSet.mappingDepartments : []
    },
    // 职员
    mappingStaffs() {
      return this.accountSet ? this.accountSet.mappingStaffs : []
    },
    // 凭证类型
    prefixDataProvider() {
      return this.accountSet ? this.accountSet.accountingDocumentType ? this.accountSet.accountingDocumentType : [] : []
    },
    isPlatformService() {
      return this.$store.getters.isAdmin
      // return this.$store.getters.userInfo.chineseName === '平台客服'
    }
  },
  watch: {
    accountSet(newVal) {
      if (newVal) {
        if (this.currentFiscalPeriod) {
          this.form.fromFP = this.currentFiscalPeriod.uuid
          this.form.toFP = this.currentFiscalPeriod.uuid
        }
        this.form.currency = this.usedCurrencyCollection[0]
      }
    }
  },
  created() {
    if (this.currentFiscalPeriod) {
      this.form.fromFP = this.currentFiscalPeriod.uuid
      this.form.toFP = this.currentFiscalPeriod.uuid
    }
    this.form.currency = this.usedCurrencyCollection[0]
    this.isExt = Number(cache.config.get('ext')) === 1
    this.updateAccountingEntryPaidOffFlag = Number(cache.config.get('updateAccountingEntryPaidOffFlag')) === 1
  },
  methods: {
    fiscalPeriodLabelFun(data) {
      if (data) {
        return this.$t('FinanceManage.N0Year0Period', [data.year, data.month])
      }
      return ''
    },
    numberFormat(value) {
      if (value) {
        return NumberUtils.formatRoundNumber(value, 2)
      }
      return ''
    },
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + '_' + accountTitle.accountTitleName : ''
    },
    selectChangeHandler(params) {
      this.form[params.key] = params.value
    },
    doSearch() {
      if (!this.form.accountTitle) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectAccountTitle'))
        this.$refs.accountTitleRef.focus()
        return
      }
      const obj = {}
      obj.accountSet = this.accountSet.uuid
      obj.dealingsCustomer = this.accountSet.dealingsCustomer
      obj.year = this.currentFiscalPeriod.year
      if (this.form.businessDateStart) {
        obj.businessDateStart = this.form.businessDateStart
      }
      if (this.form.businessDateEnd) {
        obj.businessDateEnd = this.form.businessDateEnd
      }
      const fromFP = this.fiscalPeriods.find(fp => fp.uuid === this.form.fromFP)
      const toFP = this.fiscalPeriods.find(fp => fp.uuid === this.form.toFP)
      if (fromFP) {
        obj.documentMonthStart = fromFP.month
        obj.yearSearch = fromFP.year
      } else {
        obj.documentMonthStart = this.currentFiscalPeriod.month
      }
      if (toFP) {
        obj.documentMonthEnd = toFP.month
        obj.yearSearch = toFP.year
      } else {
        obj.documentMonthEnd = this.currentFiscalPeriod.month
      }
      // 相同年
      if (fromFP && fromFP.year && toFP && toFP.year && fromFP.year !== toFP.year) {
        this.$refs.fromFPRef.focus()
        this.$message.warning(this.$t('CargoMsg.Cargo_PSFPOTSY'), this.$t('CargoMsg.Cargo_Tips'))
        return
      }

      if (this.form.accountTitle) {
        const accountTitle = this.currentAccountTitleCollection.find(title => title.uuid === this.form.accountTitle)
        obj.accountTitle = accountTitle ? accountTitle.accountTitle : ''
      }
      if (this.form.customer) {
        obj.customer = this.form.customer
      }
      if (this.form.projectNumber) {
        obj.projectNumber = this.form.projectNumber
      }
      if (this.form.currency && this.form.currency !== this.$t('CargoMsg.Cargo_ConsolidatedLocalCurrency')) {
        obj.currency = this.form.currency
      }
      if (this.form.sales) {
        obj.sales = this.form.sales
      }
      if (this.form.debitCrebit > -1) {
        obj.debitCrebit = !!this.form.debitCrebit
      }
      if (this.form.summaryText) {
        obj.summaryText = this.form.summaryText
      }
      // 核销状态 1=已核销  0=未核销
      obj.clear = this.form.clear
      // 显示期末调汇分录
      obj.showAdjustRateEntry = this.form.showAdjustRateEntry
      // 是否更新往来科目客商项目编号币种已核销（0=默认关闭，1=开启）
      obj.updateAccountingEntryPaidOffFlag = this.updateAccountingEntryPaidOffFlag
      this.setColumnVisible()
      const loading = getLoading()
      accountingEntryApi.getAccountingEntriesForDealingsCheckAccounts3ByMultiCurrency({ conditionMap: obj }).then(resp => {
        this.standardCurrencyHandler2(resp)
      }).finally(() => loading.close())
    },
    standardCurrencyHandler2(resp) {
      const result = resp.data
      if (result) {
        let debitAmount = 0.0
        let crebitAmount = 0.0
        for (const item of result) {
          if (item.FLAG === '1') { // 明细
            if (item.DEBIT_RMB) {
              debitAmount += NumberUtils.parseNumber(item.DEBIT_RMB, 0)
            }
            if (item.CREDIT_RMB) {
              crebitAmount += NumberUtils.parseNumber(item.CREDIT_RMB, 0)
            }
          }
        }
        this.lbDbAmount = NumberUtils.formatNumber(debitAmount, 2)
        this.lbCreAmount = NumberUtils.formatNumber(crebitAmount, 2)
        this.rowData = result
      }
    },
    setColumnVisible() {
      this.gridOptions.api.setColumnDefs([])
      if (this.form.currency !== this.accountSet.localCurrency) {
        this.gridOptions.api.setColumnDefs(this.columnDefs)
      } else {
        this.gridOptions.api.setColumnDefs(this.columnDefsRMB)
      }
    },
    /**
     * 核销
     */
    writeoffHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      }
      this.inputAuxiliaryNumberDialog.entryList = rows
      this.inputAuxiliaryNumberDialog.visible = true
    },
    doubleClickHandler(data) {
      if (data) {
        // 凭证号
        const documentNo = data['DOCUMENT_NO']
        // 凭证日期
        const documentDate = data['DOCUMENT_DATE']
        if (documentNo != null && documentNo !== '' && documentDate != null && documentDate !== '') {
          const obj = {}
          obj['startDate'] = DateUtils.formatStandardDate(new Date(documentDate))
          obj['endDate'] = obj['startDate']
          obj['documentNoFrom'] = documentNo
          obj['documentNoTo'] = documentNo
          const params = {}
          params.accountingSetKey = this.accountSet.uuid
          params.condition = obj
          accountingDocumentApi.query(params).then(resp => {
            this.resultHandler(resp)
          })
          // AccountingDocument.query2(this.accountSet.uuid, obj, 99, 1, resultHandler, searchDealingsCheckAccountsFault)
        }
      }
    },
    resultHandler(resp) {
      const data = resp.data
      if (data) {
        if (this.isExt) {
          this.accountingEntryWindow.accountTitleDataProvider = this.accountTitleDataProvider
        }
        this.accountingEntryWindow.voucher = data.list
        this.accountingEntryWindow.index = 0
        this.accountingEntryWindow.visible = true
      }
    },
    updateTargetDocumentNo(voucher) {
      const item = this.rowData.find(row => row.uuid === voucher.uuid)
      if (item) {
        item.targetDocumentNo = voucher.targetDocumentNo
        item.version = voucher.version
        this.gridOptions.api.refreshCells({ force: true })
      }
    },
    exportExcelHandler() {
      const columnDefs = []
      this.excelColumnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('FinanceManage.StatementOfAccountWithContacts'), this.rowData, columnDefs)
    },
    beforeLeaveHandler() {
      this.totalGroupVisible = false
    },
    updatePaidOffFlag() {
      const obj = {}
      obj.accountingSetKey = this.accountSet.uuid
      // 年度
      obj.year = this.currentFiscalPeriod.year
      // 月份
      obj.month = this.currentFiscalPeriod.month
      // 会计期间
      const fromFP = this.fiscalPeriods.find(fp => fp.uuid === this.form.fromFP)
      const toFP = this.fiscalPeriods.find(fp => fp.uuid === this.form.toFP)
      if (fromFP) {
        obj.year = fromFP.year
        obj.month = fromFP.month
      } else if (toFP) {
        obj.year = toFP.year
        obj.month = toFP.month
      }
      const loading = getLoading()
      accountingEntryApi.updatePaidOffFlag(obj).then(res => {
        //
      }).finally(() => loading.close())
    }
  }
}
</script>

<style lang="scss">
  .el-margin{
    margin: 0 0 5px 5px;
  }
  .dealings-check-accounts-view2-multi-currency {
    .el-form-item-search {
      .el-form-item__content {
        .el-radio {
          margin-right: 5px;
          .el-radio__label {
            font-size: 12px !important;
            padding-left: 2px;
          }
        }
      }
    }
  }
</style>

